(function () {
  function moveIllustrativeNote() {
    var galleryNotes = document.getElementById('msp-gallery-notes');
    var description = document.querySelector('#product .description');
    if (!galleryNotes || !description) {
      return;
    }

    var html = description.innerHTML;
    var startMarker = '<!-- vista-illustrative-note -->';
    var endMarker = '<!-- /vista-illustrative-note -->';
    var startIdx = html.indexOf(startMarker);
    var endIdx = html.indexOf(endMarker);

    if (startIdx === -1 || endIdx === -1) {
      return;
    }

    var endPos = endIdx + endMarker.length;
    var block = html.slice(startIdx, endPos);
    var before = html.slice(0, startIdx);
    var after = html.slice(endPos);

    galleryNotes.innerHTML = block;
    description.innerHTML = before + after;
  }

  function removeAvailableColorsComments(root) {
    if (!root || !root.querySelectorAll) {
      return;
    }
    var comments = root.querySelectorAll
      ? []
      : [];
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_COMMENT, null);
    while (walker.nextNode()) {
      if (/Available Colors/i.test(walker.currentNode.data)) {
        comments.push(walker.currentNode);
      }
    }
    comments.forEach(function (node) {
      if (node.parentNode) {
        node.parentNode.removeChild(node);
      }
    });
  }

  function moveAvailableColors() {
    var slot = document.getElementById('msp-vista-colors');
    var description = document.querySelector('#product .description');
    if (!slot || !description) {
      return;
    }

    var sections = description.querySelectorAll('.msp-section');
    var colorSection = null;
    for (var i = 0; i < sections.length; i++) {
      var title = sections[i].querySelector('h3.msp-section-title');
      if (title && /Available Colors/i.test(title.textContent)) {
        colorSection = sections[i];
        break;
      }
    }
    if (!colorSection) {
      slot.style.display = 'none';
      return;
    }

    slot.appendChild(colorSection);
    removeAvailableColorsComments(description);
    slot.style.display = '';
  }

  function init() {
    moveIllustrativeNote();
    moveAvailableColors();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
